<template>
  <div>
    <div class="vx-row justify-center">
      <div class="vx-col w-full">
        <vs-card>
          <div slot="header">
            <h3>Tambahkan Pengguna</h3>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <vs-input
                type="text"
                icon-pack="feather"
                icon="icon-user"
                placeholder="Nama Lengkap"
                class="w-full"
                v-model="users.name"
                :danger="errors.name.status"
                :danger-text="errors.name.text"
                val-icon-danger="icon-x"
                val-icon-pack="feather"
              />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <vs-input
                type="text"
                icon-pack="feather"
                icon="icon-map"
                placeholder="Alamat"
                class="w-full"
                v-model="users.address"
                :danger="errors.address.status"
                :danger-text="errors.address.text"
                val-icon-danger="icon-x"
                val-icon-pack="feather"
              />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <vs-input
                type="number"
                icon-pack="feather"
                icon="icon-phone"
                placeholder="No. Telepon"
                class="w-full"
                v-model="users.phone"
                :danger="errors.phone.status"
                :danger-text="errors.phone.text"
                val-icon-danger="icon-x"
                val-icon-pack="feather"
              />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <v-select
                placeholder="Gender"
                :options="sex"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="users.sex"
              />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <vs-input
                icon-pack="feather"
                icon="icon-mail"
                placeholder="Username"
                class="w-full"
                v-model="users.username"
                :danger="errors.username.status"
                :danger-text="errors.username.text"
                val-icon-danger="icon-x"
                val-icon-pack="feather"
              />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <vs-input
                type="password"
                icon-pack="feather"
                icon="icon-code"
                placeholder="Password"
                class="w-full"
                v-model="users.password"
                :danger="errors.password.status"
                :danger-text="errors.password.text"
                val-icon-danger="icon-x"
                val-icon-pack="feather"
              />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <vs-input
                type="password"
                icon-pack="feather"
                icon="icon-code"
                placeholder="Konfirmasi Password"
                class="w-full"
                v-model="users.password_confirmation"
                :danger="errors.password.status"
                :danger-text="errors.password.text"
                val-icon-danger="icon-x"
                val-icon-pack="feather"
              />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <v-select
                placeholder="Role"
                :options="userRoles"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="users.role"
              />
            </div>
          </div>
          <!-- <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <vs-upload
                action="https://jsonplaceholder.typicode.com/posts/"
                @on-success="successUpload()"
              />
            </div>
          </div> -->
          <div class="vx-row mb-3">
            <div class="vx-row w-full">
              <div class="flex flex-row">
                <vs-button
                  @click="createUser"
                  class="ml-8 w-1/2"
                  color="primary"
                  icon-pack="feather"
                  icon="icon-send"
                  type="filled"
                >Simpan</vs-button>
                <vs-button
                  @click="$router.push({name: 'users'})"
                  class="ml-3 w-1/2"
                  color="primary"
                  icon-pack="feather"
                  icon="icon-arrow-left"
                  type="border"
                >Kembali</vs-button>
              </div>
            </div>
          </div>
        </vs-card>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      users: {
        name: "",
        address: "",
        phone: "",
        sex: { id: "L", label: "Laki-Laki" },
        username: "",
        password: "",
        password_confirmation: "",
        role: { id: "general", label: "Petugas Biasa" },
        avatar: "",
        status: true
      },
      sex: [
        { id: "L", label: "Laki-Laki" },
        { id: "P", label: "Perempuan" }
      ],
      errors: {
        name: { status: false, text: "" },
        address: { status: false, text: "" },
        phone: { status: false, text: "" },
        sex: { status: false, text: "" },
        username: { status: false, text: "" },
        password: { status: false, text: "" },
        role: { status: false, text: "" },
        avatar: { status: false, text: "" },
        status: { status: false, text: "" }
      }
    };
  },
  methods: {
    createUser() {
      this.$vs.loading();
      this.$http
        .post("/app/secure/user", this.getFormatedUserData())
        .then(() => {
          this.$vs.notify({
            title: "Sukses",
            text: "Berhasil menambahkan penguna.",
            color: "success",
            position: "top-right"
          });
        })
        .catch(e => {
          let error = e.response.data.data.error;
          this.setMessageError(error);
        })
        .finally(() => {
          this.$vs.loading.close();
          this.$router.push({ name: 'users' });
        });
    },
    setMessageError(error) {
      for (var key in error) {
        if (!error.hasOwnProperty(key)) continue;
        let msgs = error[key];
        this.errors[key].text = msgs.join(". ");
        this.errors[key].status = true;
      }
    },
    removeMessageError(val = null) {
      if (val) {
        this.errors[val].status = false;
        this.errors[val].text = "";
      } else {
        for (var key in this.errors) {
          this.errors[key].status = false;
          this.errors[key].text = "";
        }
      }
    },
    getFormatedUserData() {
      let data = { ...this.users };
      data["sex"] = this.users.sex.id;
      data["role"] = this.users.role.id;
      return data;
    }
  },
  watch: {
    "users.name": function() {
      this.removeMessageError("name");
    },
    "users.address": function() {
      this.removeMessageError("address");
    },
    "users.phone": function() {
      this.removeMessageError("phone");
    },
    "users.username": function() {
      this.removeMessageError("username");
    },
    "users.password": function() {
      this.removeMessageError("password");
    }
  },
  computed: {
    ...mapGetters(["userRoles"])
  },
  components: {
    "v-select": vSelect
  }
};
</script>